let cookieStateApplied = false // cookie massage applied
let cookieStateStats = false // cookies for stats like google analytics
let cookieStateAdds = false // cookies for marketing like facebook pixel
let cookieStateMedia = false // cookies for media like youtube, facebook, instagram

let cookieContent = document.getElementById('cookie-content') // cookie main content

let cookieButtonAccept = document.getElementById('cookie-button-accept') // cookie accept all
let cookieButtonIndividual = document.getElementById('cookie-button-individual') // cookie accept only checked
let cookieButtonDeny = document.getElementById('cookie-button-deny') // cookie accept only essential

let cookieButtonSettings = document.getElementById('cookie-button-settings') // show cookie content (again)
let cookieButtonIndividualSettings = document.getElementById('cookie-button-show-individual-settings') // show individual settings
let cookieIndividualSettings = document.getElementById('cookie-individual-settings') // cookie individual content

let inputSwitchStats = document.getElementById('switch-stats') // input tag stats
let inputSwitchAdds = document.getElementById('switch-adds') // input tag adds
let inputSwitchMedia = document.getElementById('switch-media') // input tag media

/**
 * function set cookies for stats
 */
function setCookieStatsContent() {
    if (cookieStateStats) {
        window['ga-disable-UA-130942188-1'] = false
        console.log('enable google analytics')
    } else {
        window['ga-disable-UA-130942188-1'] = true
        console.log('disable google analytics')
    }
}

/**
 * function set cookies for adds
 */
function setCookieAddsContent() {

}

/**
 * function set cookies for media
 */
function setCookieMediaContent() {

}

/**
 * save cookie decision to local storage
 */
function saveCookieDecisionToLocalStorage(stats, adds, media) {
    if (stats) {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(true))
    } else {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(false))
    }

    if (adds) {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(true))
    } else {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(false))
    }

    if (media) {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(true))
    } else {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(false))
    }

    // set applied state
    localStorage.setItem('pixelparker_cookie_applied', JSON.stringify(true))
    // refresh page and load plugins
    window.location.reload(true)
}

/**
 * init values if null
 */
function initValuesIfNull() {
    if (cookieStateApplied === null || cookieStateApplied == false) {
        localStorage.setItem('pixelparker_cookie_applied', JSON.stringify(false))
        cookieStateApplied = false
        showHideCookieSettings()
    }
    if (cookieStateStats === null) {
        localStorage.setItem('pixelparker_cookie_stats_accepted', JSON.stringify(false))
        cookieStateStats = false
    }
    if (cookieStateAdds === null) {
        localStorage.setItem('pixelparker_cookie_adds_accepted', JSON.stringify(false))
        cookieStateAdds = false
    }
    if (cookieStateMedia === null) {
        localStorage.setItem('pixelparker_cookie_media_accepted', JSON.stringify(false))
        cookieStateMedia = false
    }
    reactOnState()
}

/**
 * read and check cookie decision from local storage
 */
function readAndCheckCookieDecisionFromLocalStorage() {
    cookieStateApplied = (localStorage.getItem('pixelparker_cookie_applied') === 'true')
    cookieStateStats = (localStorage.getItem('pixelparker_cookie_stats_accepted') === 'true')
    cookieStateAdds = (localStorage.getItem('pixelparker_cookie_adds_accepted') === 'true')
    cookieStateMedia = (localStorage.getItem('pixelparker_cookie_media_accepted') === 'true')
    console.log("cookies: set_ ", cookieStateApplied, " stats_ ", cookieStateStats, " adds_ ", cookieStateAdds, " media_ ", cookieStateMedia)
    initValuesIfNull()
    setCookieStatsContent()
    setCookieAddsContent()
    setCookieMediaContent()
}

/**
 * show hide cookie Settings
 */
function showHideCookieSettings() {
    cookieContent.classList.toggle('d-flex')
    cookieContent.classList.toggle('d-none')
}

/**
 * react on state -> show or hide content
 */
function reactOnState() {
    //  set checked state on cookie individual parts (stats, adds, media)
    if (inputSwitchStats) {
        inputSwitchStats.checked = cookieStateStats
    }

    if (inputSwitchAdds) {
        inputSwitchAdds.checked = cookieStateAdds
    }

    if (inputSwitchMedia) {
        inputSwitchMedia.checked = cookieStateMedia
    }
}

/**
 * show or hide individual cookie settings
 */
function showHideIndividualSettings() {
    cookieIndividualSettings.classList.toggle('d-block')
    cookieIndividualSettings.classList.toggle('d-none')
}

/**
 * cookie button click event
 */
if (cookieButtonAccept) {
    cookieButtonAccept.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(true, true, true)
    })
}
if (cookieButtonIndividual && inputSwitchStats && inputSwitchAdds && inputSwitchMedia) {
    cookieButtonIndividual.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(inputSwitchStats.checked, inputSwitchAdds.checked, inputSwitchMedia.checked)
    })
}
if (cookieButtonDeny) {
    cookieButtonDeny.addEventListener('click', function () {
        saveCookieDecisionToLocalStorage(false, false, false)
    })
}
if (cookieButtonSettings) {
    cookieButtonSettings.addEventListener('click', function () {
        showHideCookieSettings()
    })

}
if (cookieButtonIndividualSettings) {
    cookieButtonIndividualSettings.addEventListener('click', function () {
        showHideIndividualSettings()
    })
}

/**
 * document content loaded function
 */
document.addEventListener('DOMContentLoaded', function () {
    readAndCheckCookieDecisionFromLocalStorage()
})
